// Phase 5a-fix — calm progress UI while the detached scoring + AI task
// runs server-side. No skeleton screen of the preview, no motion beyond
// the unobtrusive gold pulse. Phase 4 owns polish. Extracted verbatim
// from AuditPreview.jsx (W2b) — same DOM, same test-ids, same inline
// styles, same copy.
export default function PreviewLoading({ pollAttempts }) {
  return (
    <div
      className="sf-container"
      style={{ padding: "120px 24px", display: "flex", justifyContent: "center" }}
      data-testid="preview-generating"
    >
      <div style={{ maxWidth: 560, textAlign: "left" }}>
        <div
          data-testid="preview-generating-pulse"
          style={{
            width: 14, height: 14, borderRadius: "50%",
            backgroundColor: "var(--sf-gold)",
            boxShadow: "0 0 0 0 rgba(201,162,74,0.7)",
            animation: "sf-pulse 1.6s ease-out infinite",
            marginBottom: 30,
          }}
        />
        <h1
          className="sf-display"
          style={{ fontSize: 30, lineHeight: 1.15, marginBottom: 14 }}
        >
          SystemForge is analyzing your answers.
        </h1>
        <p style={{ color: "var(--sf-muted)", lineHeight: 1.55 }}>
          SystemForge is scoring your business systems, classifying your Business Health, and preparing your executive summary. This usually takes less than 2 minutes.
        </p>
        {pollAttempts > 0 && (
          <div
            className="sf-mono"
            style={{ marginTop: 22, fontSize: 11, color: "var(--sf-muted)",
                     letterSpacing: "0.08em", opacity: 0.6 }}
            data-testid="preview-generating-attempts"
          >
            still working… {pollAttempts}/{60}
          </div>
        )}
      </div>
      <style>{`
        @keyframes sf-pulse {
          0%   { box-shadow: 0 0 0 0   rgba(201,162,74,0.55); }
          70%  { box-shadow: 0 0 0 14px rgba(201,162,74,0);   }
          100% { box-shadow: 0 0 0 0   rgba(201,162,74,0);   }
        }
      `}</style>
    </div>
  );
}
